import React, { useEffect, useState } from 'react';
import {
  buriedPagePoint,
  useInitBuriedPointInfo,
} from '../../../operationLog/buriedPoint';
import pdfReportFunc from '@/pages/opinion/operationLog/pages/pdfReport';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { connect, useParams } from 'umi';
import usePageName from '@op/hooks/usePageName';
function PDFReport({ listMenu, location }: any) {
  const params: any = useParams();

  const { pageName } = usePageName({ listMenu, menuId: params.pdfId });

  useInitBuriedPointInfo({
    buriedPoint: pdfReportFunc(
      pageName || location.pathname,
      location.pathname,
    ),
    triggerPagePoint: false,
  });

  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    setLoading(true);
    const { query } = location;
    setPdfUrl(query.pdfUrl);
    setLoading(false);
  }, [location]);

  useEffect(() => {
    if (pdfUrl) {
      buriedPagePoint();
    }
  }, [pdfUrl]);

  return (
    <CardCommon
      contentCard
      empty={!pdfUrl}
      bodyStyle={{ height: '100%' }}
      loading={loading}
      loadingHeight={550}
      emptyHeight={550}
    >
      <iframe style={{ width: '100%', height: '100%' }} src={pdfUrl}></iframe>
    </CardCommon>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    listMenu: opinionCommon.listMenu,
  };
})(PDFReport);
